import { PolymorphicComponentProps } from "@omni/types/components/utils/polymorphic.types";
import { cn } from "@omni/utils/styles";
import React from "react";

export type InputGroupComponentProps = {};

export type InputGroupProps<T extends React.ElementType> =
    PolymorphicComponentProps<T, InputGroupComponentProps, "div">;

const InputGroup = <T extends React.ElementType = "div">({
    className,
    tag,
    ...attributes
}: InputGroupProps<T>) => {
    const Tag = tag || ("div" as React.ElementType);

    return (
        <Tag
            {...attributes}
            className={cn(
                "tw:flex tw:relative tw:items-stretch tw:w-full",
                "tw:group/inputgroup",
                className
            )}
        />
    );
};

export { InputGroup };
